import type { SxStyle, SxStyleFunc } from '@aibees/shared/theme';

export const root: SxStyleFunc<boolean | undefined> = (hidden) => ({
  display: hidden ? 'none' : 'inherit',
});

export const add: SxStyle = {
  fontSize: (p) => p.typography.caption.fontSize,
  fontWeight: (p) => p.typography.fontWeightSemiBold,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 1,
};
